import React from "react";
import "./BlogItem.scss"
import moment from "moment";
import arrow from "../../assets/arrow.svg"
import { useHistory } from "react-router";
const BlogItem = ({ item, isHome = true, isFilter = false }) => {
    const style = isFilter ? "BlogItem-Filter" : "BlogItem"
    const history = useHistory()
    return (
        <div className={style}>
            <img alt="" src={item?.hero?.background_image} className={`${style}-img`} />
            <div className={`${style}-content`}>
                {/* {isHome ? <div className={`${style}-content-title`}>{moment(item?.published_at).format("MMMM DD, YYYY")} • {item?.title}</div> :
                    <div className={`${style}-content-title`}>BY {item?.author_name} • {moment(item?.published_at).format("MMMM DD, YYYY")}</div>} */}
                <div className={`${style}-content-title`}>BY {item?.author_name} • {moment(item?.published_at).format("MMMM DD, YYYY")}</div>
                <div className={`${style}-content-header`} >{item?.title}</div>
                <div className={`${style}-content-text`} >{item?.excerpt}</div>
                <div className={`${style}-content-readmore`}
                    onClick={() => {
                        history.push(`/blog/${item?.slug}`)
                    }}>READ MORE
                    <img alt="" src={arrow} />
                </div>

            </div>
        </div>
    )
}
export default BlogItem